// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const DogPurchaseTransactionSuccess = () => import(/* webpackPrefetch: true, webpackChunkName: "dog-purchase-transaction-success" */ '@/app/views/client-view/dog-purchase-public-page/components/dog-purchase-transaction-success/dog-purchase-transaction-success.vue');
const DogPurchaseTransactionFailed = () => import(/* webpackPrefetch: true, webpackChunkName: "dog-purchase-transaction-failed" */ '@/app/views/client-view/dog-purchase-public-page/components/dog-purchase-transaction-failed/dog-purchase-transaction-failed.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');

// Third Party
import $ from 'jquery';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Services
import DefaultSettingsService from '@/app/services/main/default-settings/default-settings-service';
import PaymentService from "@/app/services/main/payment/payment-service";
import PetOrderService from "@/app/services/main/pet-order/pet-order-service";

export default {
	name: 'DogPurchaseTransaction',
	components: {
		ClientHeader,
		DogPurchaseTransactionSuccess,
		DogPurchaseTransactionFailed,
		TheFooter
	},
	computed: {
        isNativeApp() {
			return this.$store.getters.getIsNativeApp;
		}
    },
	data() {
		return {
			appLinks : {
				appStoreLink: 'https://play.google.com/store/apps/details?id=com.lmdcmobile',
				googlePlayLink: 'https://apps.apple.com/ph/app/love-my-dog-club/id1523977343'
			},
			selectedRoute: '',
			isAPILoading: true,
			dogPurchaseDetails: null
		}
	},
	created() {
		$('html, body').animate({scrollTop: 0}, 500);
		this.getStoreLink();
		this.getLatitudeStatus();
	},
	methods: {
		getLatitudeStatus() {
			const {
				merchantReference,
				gatewayReference,
				transactionReference,
				status,
				referenceId,
				token,
				reference,
			} = this.$route.query;

			let latitudeInterestFree = {
				merchantReference,
				gatewayReference,
				transactionReference,
				reference
			}

			if (referenceId) {
				if (status === 'success') {
					this.getDogPurchaseDetails(referenceId, token);
				} else {
					this.setFailedStatus(reference);
				}
			} else {
				this.updateStatusLatitude(latitudeInterestFree);
			}
		},
		updateStatusLatitude(latitudeInterestFree) {
			this.isAPILoading = true;
			PaymentService.verifyLatitude(latitudeInterestFree)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {

						if (res.data.referenceId.status !== 'FAILED') {
							this.getDogPurchaseDetails(res.data.referenceId.reference, res.data.referenceId.token);
						} else {
							this.setFailedStatus(latitudeInterestFree.reference);
						}
					} else {
						this.setFailedStatus(latitudeInterestFree.reference);
					}
				})
				.finally(()=> {
					this.isAPILoading = false;
				});
		},
		getDogPurchaseDetails(referenceId, token) {
			PetOrderService.getDogPurchase({f_referenceId: referenceId, f_token: token})
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.dogPurchaseDetails = res.data;
					}
				})
			this.selectedRoute = 'dog-purchase-transaction-success'
			this.$router.replace(`/landing-transaction-status?status=success&referenceId=${referenceId}&token=${token}`);
		},
		setFailedStatus(referenceId) {
			this.selectedRoute = 'dog-purchase-transaction-failed'
			this.$router.replace(`/landing-transaction-status?status=failed&referenceId=${referenceId}`); 
		},
		getStoreLink() {
			const queryParams = {
				f_code: 'LINK',
				f_environment: 'MOB'
			}

			DefaultSettingsService.getDefaultSettings(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.appLinks.googlePlayLink = res.data.find(data => data.id === 1).value;
						this.appLinks.appStoreLink = res.data.find(data => data.id === 2).value;
					}
				})
		}
	}
}